import { useLanguage } from "../i18n/LanguageContext";
import "./Performances.css";

function VideoCard({ video }) {
  return (
    <div className="video-card">
      <div className="video-wrapper">
        {video.videoSrc ? (
          <video
            src={video.videoSrc}
            controls
            preload="metadata"
            title={video.title}
          />
        ) : (
          <iframe
            src={video.embedUrl}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )}
      </div>
      <div className="video-info">
        <h3 className="video-title">{video.title}</h3>
        {video.description && (
          <p className="video-description">{video.description}</p>
        )}
      </div>
    </div>
  );
}

export default function Performances() {
  const { t } = useLanguage();

  return (
    <section id="performances" className="performances-section" aria-label="Performances">
      <div className="section-header">
        <h2 className="section-title">{t.performances.sectionTitle}</h2>
        <div className="section-divider" aria-hidden="true">
          <span className="divider-dot" />
          <span className="divider-line" />
          <span className="divider-dot" />
        </div>
      </div>
      <div className="videos-container">
        {t.performances.videos.map((video, i) => (
          <VideoCard key={i} video={video} />
        ))}
      </div>
    </section>
  );
}
